<template>
  <div class="layout">
    <aside class="sidebar">
      <div class="top-icons">
        <button class="icon-btn">
            <img :src="logoImg" class="brand-logo" />
          </button>
        

        <router-link to="/manager/bots" class="icon-link">
          <button class="icon-btn">
            <Workflow :size="18" />
          </button>
        </router-link>

        <!-- <router-link to="/manager/dashboard" class="icon-link">
          <button class="icon-btn">
            
            <LayoutDashboard :size="18" />
            
          </button>
        </router-link> -->
      </div>

      <div class="bottom-icons">
        <div class="avatar">
          {{ userInitials }}
        </div>
        <button class="icon-btn">◐</button>
      </div>
    </aside>

    <div class="main-area">
      <header class="top">
        <div>
          <b>Manager Portal</b>
          <small> — {{ user?.username }} ({{ user?.role }})</small>
        </div>
        <div class="actions">
          <button @click="refreshAll">Refresh</button>
          <button class="logout" @click="logout">Logout</button>
          <!-- <button @click="$router.push('/manager/bots')">Flows</button> -->
        </div>
      </header>

      <main class="grid">
        <section class="card">
          <div class="convs">
            <div class="tabs">
              <button class="tab" :class="{ on: filter === 'OPEN' }" @click="setFilter('OPEN')">OPEN</button>
              <button class="tab" :class="{ on: filter === 'QUEUED' }" @click="setFilter('QUEUED')">QUEUED</button>
              <button class="tab" :class="{ on: filter === 'CLOSED' }" @click="setFilter('CLOSED')">CLOSED</button>
            </div>

              <!-- {{ conversations }} -->
            <ConversationCard
              v-for="c in conversations"
              :key="c.conversation_id"
              :c="c"
              :agents="agents"
              @view="openReadOnlyChat"
              @assign="assign"
              @close="closeConv"
            />

            <div v-if="!conversations.length" class="muted" style="padding: 10px;">
              No conversations found.
            </div>
          </div>
        </section>

        <section class="card">
          <div class="cardHead">
            <h3>Conversations</h3>
<!-- 
            <button @click="exportChatPDF(chatMessages)">
              Export Chat PDF
            </button> -->
          </div>

          <div v-if="chatModalOpen" class="chatContainer">
            <div class="chatHeader">
              <div>
                <h3 style="margin: 0;">
                  #{{ activeConversation?.conversation_id }}
                </h3>

                <small class="muted">
                  {{ activeConversation?.visitor_name || "Visitor" }}
                  <span v-if="activeConversation?.visitor_phone">
                    • {{ activeConversation.visitor_phone }}
                  </span>
                  <span v-if="activeConversation?.assigned_username">
                    • @{{ activeConversation.assigned_username }}
                  </span>
                  <span v-if="activeConversation?.dispo_status">
                    •  {{ activeConversation.dispo_status }}
                  </span>
                </small>
              </div>

              <!-- <button v-if="activeConversation?.status != 'CLOSED'" class="logout" @click="closeReadOnlyChat">
                Close
              </button> -->
            </div>

            <div class="messages">
              <div v-if="chatLoading" class="muted">Loading messages...</div>

              <div v-else-if="!chatMessages.length" class="muted">
                No messages found.
              </div>

              <div
                v-for="m in chatMessages"
                :key="m.id"
                class="msg"
                :class="messageClass(m)"
              >
  
                <StoryCard
                  v-if="m.sender_type != 'SYSTEM'"
                  :name="messageSender(m)"
                  :date="formatTime(m.created_at)"
                  :message="m.body"
                />

                <div class="readOnlyBar" v-if="m.sender_type == 'SYSTEM'">
                  {{ m.body }}
                  {{ formatTime(m.created_at) }}
                </div>
              </div>
            </div>

            <div class="readOnlyBar">
              Read only mode — managers can view ongoing chat but cannot reply from here.
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script setup>
import { Workflow } from 'lucide-vue-next'

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/services/auth";
import VARS from "@/services/vars";
import StoryCard from "@/components/StoryCard.vue";
import ConversationCard from "@/components/ConversationCard.vue";
import logoImg from "@/assets/images/logo.png";
// import { LayoutDashboard } from "lucide-vue-next";
// import jsPDF from "jspdf";



const API_BASE = VARS.API_URL;
const router = useRouter();
const user = ref(auth.user);

const userInitials = computed(() => {
  const name = user.value?.username || "U";
  return name
    .split(" ")
    .map(v => v[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
});

const agents = ref([]);
const conversations = ref([]);
const filter = ref("OPEN");
const assignTo = ref({});

const chatModalOpen = ref(false);
const activeConversation = ref(null);
const chatMessages = ref([]);
const chatLoading = ref(false);

function logout() {
  auth.clear();
  router.push("/");
}



// function exportChatPDF(chatMessages) {
//   const doc = new jsPDF();

//   let y = 10;

//   chatMessages.forEach((msg) => {
//     const sender =
//       msg.sender_type === "AGENT"
//         ? "Agent"
//         : msg.sender_type === "VISITOR"
//         ? "Customer"
//         : "Bot";

//     const time = new Date(msg.created_at).toLocaleTimeString();

//     const text = `[${time}] ${sender}: ${msg.body}`;

//     const lines = doc.splitTextToSize(text, 180);

//     doc.text(lines, 10, y);
//     y += lines.length * 6;

//     // page break
//     if (y > 280) {
//       doc.addPage();
//       y = 10;
//     }
//   });

//   doc.save(`chat-${Date.now()}.pdf`);
// }



async function apiGet(path) {
  const r = await fetch(API_BASE + path, {
    headers: { Authorization: "Bearer " + auth.token },
  });

  if (r.status === 401) {
    logout();
    throw new Error("401");
  }

  const data = await r.json();
  if (!data.ok) throw new Error(data.message || "API_ERROR");
  return data;
}

async function apiPost(path, body) {
  const r = await fetch(API_BASE + path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify(body || {}),
  });

  if (r.status === 401) {
    logout();
    throw new Error("401");
  }

  const data = await r.json();
  if (!data.ok) throw new Error(data.message || "API_ERROR");
  return data;
}

async function loadAgents() {
  const data = await apiGet("/api/manager/agents");
  agents.value = data.agents || [];
}

async function loadConversations() {
  const data = await apiGet(`/api/manager/conversations?filter=${filter.value}`);
  conversations.value = data.conversations || [];
}

async function refreshAll() {
  await loadAgents();
  await loadConversations();
}

async function setFilter(v) {
  filter.value = v;
  await loadConversations();
}

async function assign(conversationId) {
  const agentId = assignTo.value[conversationId];
  if (!agentId) return;

  await apiPost(`/api/manager/conversation/${conversationId}/assign`, {
    agentId: Number(agentId),
  });

  await refreshAll();
}

async function closeConv(conversationId) {
  await apiPost(`/api/manager/conversation/${conversationId}/close`, {});
  await refreshAll();
}

async function openReadOnlyChat(conv) {
  activeConversation.value = conv;
  chatModalOpen.value = true;
  chatLoading.value = true;
  chatMessages.value = [];

  try {
    const data = await apiGet(`/api/manager/conversation/${conv.conversation_id}/messages`);
    chatMessages.value = data.messages || [];
  } catch (e) {
    console.error("Failed to load messages", e);
    chatMessages.value = [];
  } finally {
    chatLoading.value = false;
  }
}

// function closeReadOnlyChat() {
//   chatModalOpen.value = false;
//   activeConversation.value = null;
//   chatMessages.value = [];
// }

function messageSender(m) {
  if (m.sender_type === "AGENT") return m.sender_name || "Agent";
  if (m.sender_type === "VISITOR") return "Visitor";
  if (m.sender_type === "BOT") return "Bot";
  return m.sender_type || "System";
}

function messageClass(m) {
  if (m.sender_type === "AGENT") return "agentMsg";
  if (m.sender_type === "VISITOR") return "visitorMsg";
  if (m.sender_type === "WHATSAPP") return "visitorMsg";
  if (m.sender_type === "BOT") return "botMsg";
  return "systemMsg";
}

function formatTime(v) {
  if (!v) return "";
  try {
    return new Date(v).toLocaleString();
  } catch {
    return v;
  }
}

onMounted(async () => {
  if (!auth.token) return router.push("/");
  if (!["admin", "manager"].includes(auth.user?.role)) return router.push("/inbox");
  await refreshAll();
});
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
  background: #f5f7fb;
  font-family: Arial, sans-serif;
}

.sidebar {
  width: 72px;
  min-width: 72px;
  background: #ffffff;
  border-right: 1px solid #e9edf3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 14px 10px;
  box-sizing: border-box;
}

.top-icons,
.bottom-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.icon-link {
  text-decoration: none;
}

.grid-btn,
.icon-btn {
  width: 42px;
  height: 42px;
  border: 1px solid #dde3ec;
  border-radius: 12px;
  background: #fff;
  color: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  font-size: 18px;
}

.grid-btn:hover,
.icon-btn:hover {
  background: #f2f6ff;
  border-color: #cfdcff;
}

.icon-btn.active {
  background: #0b66d1;
  color: #fff;
  border-color: #0b66d1;
}

.grid-btn {
  display: grid;
  grid-template-columns: repeat(3, 4px);
  grid-template-rows: repeat(3, 4px);
  gap: 4px;
}

.grid-btn span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #333;
  display: block;
}

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #0b66d1;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}

.main-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #e9edf3;
  background: #fff;
}

.actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

button {
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  background: #0b66d1;
  color: #fff;
  cursor: pointer;
}

button.logout {
  background: #444;
}

button.danger {
  background: #e74c3c;
}

button.secondary {
  background: #6c757d;
}

.grid {
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 12px;
  padding: 12px;
  flex: 1;
  min-height: 0;
}

.card {
  border: 1px solid #e9edf3;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  min-height: 0;
}

.cardHead {
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

h3 {
  margin: 0;
}

.agents,
.convs {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: calc(100vh - 110px);
  overflow: auto;
}

.agent,
.conv {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 12px;
  background: #fafafa;
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tab {
  background: #eee;
  color: #000;
}

.tab.on {
  background: #e6f0ff;
  color: #0b66d1;
  border: 2px solid #0b66d1;
}

.preview {
  margin-top: 6px;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

select {
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

.muted {
  color: #777;
  font-size: 12px;
}

.pill {
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #ddd;
  font-size: 11px;
  background: #f5f5f5;
}

.pill.READY {
  background: #e9f6ee;
  border-color: #bfe6cc;
}
.pill.LIVE {
  background: #4fc77d;
  border-color: #abe4be;
  color: #fafafa;
}
.pill.AWAY {
  background: #fff5e6;
  border-color: #ffe0a3;
}
.pill.OFFLINE {
  background: #f5f5f5;
  border-color: #ddd;
}
.pill.OPEN {
  background: #e9f6ee;
  border-color: #bfe6cc;
}
.pill.CLOSED {
  background: #f5f5f5;
  border-color: #ddd;
}
.pill.QUEUED {
  background: #fff5e6;
  border-color: #ffe0a3;
}

.chatContainer {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px);
  background: #fff;
}

.chatHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  border-bottom: 1px solid #eee;
}

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f8f9fb;
}

.msg {
  max-width: 75%;
  border-radius: 12px;
  border: 1px solid #ddd;
  background: white;
  margin-bottom: 10px;
}

.agentMsg {
  align-self: flex-end;
  background: #eaf3ff;
  border-color: #cfe0ff;
}

.visitorMsg {
  align-self: flex-start;
  background: #fff;
}

.botMsg {
  align-self: flex-end;
  background: #eefaf0;
  border-color: #cfead5;
}

.systemMsg {
  align-self: center;
  background: #f1f1f1;
  max-width: 90%;
}

.readOnlyBar {
  padding: 12px 14px;
  border-top: 1px solid #eee;
  background: #fafafa;
  color: #666;
  font-size: 13px;
  text-align: center;
}

.emptyState {
  height: calc(100vh - 110px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-size: 14px;
}


.brand-logo {
  width: 40px;
}


@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .sidebar {
    width: 60px;
    min-width: 60px;
    padding: 10px 8px;
  }

  .grid-btn,
  .icon-btn,
  .avatar {
    width: 38px;
    height: 38px;
  }

  .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>